import React from 'react'
import { ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useBilling, useManageSubscription } from '@/entities/billing'
import { format } from 'date-fns'

export const BillingCard = React.memo(function BillingCard() {
  const { data, isLoading } = useBilling()
  const manageSubscription = useManageSubscription()

  const handleManageSubscription = () => {
    manageSubscription.mutate()
  }

  // Show loading state while data is being fetched
  if (isLoading || !data) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-2 mb-2 w-full">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded mb-1"></div>
          <div className="h-3 bg-gray-200 rounded mb-1"></div>
          <div className="h-3 bg-gray-200 rounded"></div>
        </div>
      </div>
    )
  }

  const { minutesBalance, stripeCustomer } = data

  return (
    <div className="bg-white rounded-lg shadow-sm p-2 mb-2 w-full">
      <div className="flex flex-col justify-between items-left">
        <span className="text-body mb-0 font-bold text-gray-900">
          {minutesBalance.usd_balance.toLocaleString(['en-US'], {
            style: 'currency',
            currency: 'USD',
          })}
        </span>
        <span className="text-detail mb-1 h-fit ml-1 text-gray-500 font-medium">
          This month usage:{' '}
          {minutesBalance.month_minutes.toLocaleString(['en-US'], {
            maximumFractionDigits: 0,
          })}{' '}
          minutes
        </span>
        <span className="text-detail text-gray-400">
          {minutesBalance.updated
            ? `Updated: ${format(new Date(minutesBalance.updated), 'MMM dd')}`
            : 'Not updated yet'}
        </span>
      </div>
      <Button
        variant="outline"
        onClick={handleManageSubscription}
        disabled={!stripeCustomer.stripeCustomerId || manageSubscription.isPending}
        className="mt-2 h-6 px-2 w-full"
        size="sm"
      >
        <ExternalLink className="h-3 w-3 mr-1" /> Manage
      </Button>
    </div>
  )
})